module.exports = __webpack_public_path__ + "img/closed-eye.b0b365e5.svg";